
export type BitType = 'n'|'e'|'w'|'s'|'bu'|'rl'|'ne'|'nw'|'se'|'sw'|'bite';

export class Bit {
  type: BitType = 'w';
  d12: string;
  tooltip?: string;
  constructor(public x = 0, public y = 0) {}
}

